module.exports = __webpack_public_path__ + "static/Marcelo-5675979b54ad017eaa30f339638073b4.png";